<template>
  <div id="welcome">
    <popup ref="popupDialog" type="center" @close="popClose" :coverClose="true">
      <div class="welcome_panel">
        <div class="panel_main">
          <div class="panel_title">欢迎来到<img class="logo_img" src="./img/header/icon_img1_2.png"><span>Runway</span>中文站</div>
          <div class="panel_subtitle">Runway、Pika、Luma、Viggle等Ai视频大模型</div>
          <div class="panel_content">
            <div class="panel_item play_video">
              <div class="item_top">超过 99% 新用户观看了福利视频</div>
              <div class="item_content" @click="showVideDialog">
                <img class="video_icon" src="./img/video/img_icon_16.png" alt="">
                <div class="content_text"><span class="text_span">Runway Ai视频创作新手教程
                  <img class="hot_icon" src="./img/video/img_icon_02.gif" alt="">
                </span>
                </div>
                <div class="content_tips">新手如何一键创作高质量视频？</div>
              </div>
            </div>
          </div>
          <div class="tuiNext"  @click="popClose">
            下次再观看，点此跳过 >>
          </div>
          <div class="close_btn" @click="popClose">
            <img class="closeTuiImg" src="./img/video/img_icon_10.png"/>
          </div>
        </div>
      </div>
    </popup>
    <videoDialog ref="videoDialogPopup" v-show="isShowVideo" @popClose="popClose"></videoDialog>
  </div>
</template>
<script>
import videoDialog from "@/components/VideoDialogAd.vue"
import popup from "COMPONENTS/Popup.vue";
import LocalCache from "@/stores/cache.js"

export default {
  components: {
    videoDialog,
    popup,
  },
  data() {
    return {
      isShowVideo: false,

    };
  },
  methods:{
    close() {
      this.theToast = false

    },
    show() {
      console.log(1111)
      this.$refs.popupDialog.show()
    },
    open () {
      this.theToast = false
      this.$store.commit('setToastVip', false)
      this.$emit("vipOpenHandle")
    },
    popClose () {
      this.$refs.popupDialog.close()
      // let tgad = LocalCache.getCache("tgad") || ""
      // let adsid = LocalCache.getCache("site_id") || ""
      // location.href = MAIN_URLROOT + "?adaid=" + AD_AID + "&tgad=" + tgad + "&adsid=" + adsid
      //
      let tgad = LocalCache.getCache("tgad") || ""
      let adsid = LocalCache.getCache("site_id") || ""
      
      let msclkid = LocalCache.getCache("msclkid") || ""
      let bd_vid = LocalCache.getCache("bd_vid") || ""
      let qhclickid = LocalCache.getCache("qhclickid") || ""
      let sourceid = LocalCache.getCache("sourceid") || ""
      
      let url = MAIN_URLROOT + "?adaid=" + AD_AID + "&tgad=" + tgad + "&adsid=" + adsid
      
      if(msclkid){
          url += "&msclkid=" + msclkid
      }
      if(bd_vid){
          url += "&bd_vid=" + bd_vid
      }
      if(qhclickid){
          url += "&qhclickid=" + qhclickid
      }
      if(sourceid){
          url += "&sourceid=" + sourceid
      }

      location.href = url
    },
    showVideDialog () {
      this.$refs.popupDialog.close()
      this.isShowVideo = true
      this.$refs.videoDialogPopup.playVideo()
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.welcome_panel {
  display: flex;
  //justify-content: center;
  //align-items: center;
  font-size: 12px;
  color: #000;
  //width: 100%;
  //height: 100%;
  //background-color: rgba(0, 0, 0, 0.28);
//position: absolute;
//  top: 0;
//  left: 0;
  .panel_main {
    width: 320px;
    // height: 560px;
    position: relative;
    padding: 30px 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 3px;

    .panel_title {
      font-size: 22px;
      line-height: 40px;

      span{
        margin: 6px;
      }
      .logo_img {
        width: 22px;
        margin: -3px 0px 0 5px;
        vertical-align: middle;
        border-radius: 4px;
        overflow: hidden;
      }
    }

    .panel_subtitle {
      font-size: 13px;
      line-height: 40px;
      color: #999;
      // font-weight: bold;
    }

    .panel_content {
      padding-top: 10px;
      display: flex;

      .panel_item {
        flex-grow: 1;
        width: 0;

        &.play_video {
          //margin-right: 12px;

          .item_top {
            border: 1px solid #ccc;
            background-color: #f5f5f5;
            line-height: 50px;
            position: relative;
            color: #999;
            border-radius: 3px;

            &::after {
              content: "";
              position: absolute;
              display: block;
              width: 14px;
              height: 14px;
              border: 1px solid #ccc;
              border-top-color: transparent;
              border-left-color: transparent;
              left: 50%;
              bottom: -7px;
              box-sizing: border-box;
              transform-origin: center;
              transform: rotate(45deg);
              background-color: #f5f5f5;
            }
          }

          .item_content {
            background-color: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .video_icon {
              width: 30px;
              display: block;
              margin: 0 auto;
              cursor: pointer;
            }

            .content_text {
              //line-height: 46px;
              margin: 16px 0;

              .text_span {
                color: #ec3b3b;
                position: relative;

                .hot_icon {
                  position: absolute;
                  top: -15px;
                  right: -23px;
                }
              }
            }

            .content_tips {
              color: #999;
              //line-height: 46px;
            }
          }
        }

        .item_top {
          height: 52px;
          margin-bottom: 11px;
        }

        .item_content {
          height: 160px;
          border-radius: 3px;
          border: 1px solid #ccc;
          position: relative;
        }
      }
    }

    .tuiNext{
      color: #ccc;
      margin-top: 20px;
      font-size: 14px;
    }

    .close_btn {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translate(-50%);
      width: 30px;
      height: 30px;
      cursor: pointer;
      border-radius: 50%;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;

      .closeTuiImg {
        width: 15px;
        height: 15px;
      }
    }
  }
}
</style>